const INITIAL_STATE = {list: []}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'GRUPO_FETCHED':
            return { ...state, list: action.payload.data }
        case 'GRUPO_PAGE':
            return { ...state, paginaAtual: action.payload };
        default:
            return state
    }
}